"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadTask = void 0;
var axios_1 = __importDefault(require("axios"));
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var utils_1 = require("../utils");
var types_1 = require("../types");
var upload_1 = require("../constants/upload");
var UploadTask = /** @class */ (function () {
    function UploadTask() {
    }
    UploadTask.prototype.resolveUrl = function (env, domain) {
        var ts = Date.now();
        var adt = this.adjustTimeService.getTimestamp() || Date.now();
        var appId = (0, utils_1.resolveAppId)();
        var finalDomain = domain || upload_1.UPLOAD_DOMAIN;
        var urlPath = "/behavior/v4/batch";
        if (finalDomain === upload_1.EU_UPLOAD_DOMAIN) {
            // 欧洲使用另外的路径
            urlPath = "/web/behavior/v4";
        }
        return "https://".concat(env === "prod" ? "" : "test-").concat(finalDomain).concat(urlPath, "?ts=").concat(ts, "&adt=").concat(adt, "&app_id=").concat(appId);
    };
    UploadTask.prototype.upload = function (data, config) {
        return __awaiter(this, void 0, void 0, function () {
            var resp, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, axios_1.default)({
                                method: "POST",
                                url: this.resolveUrl(config.env, config.uploadDomain),
                                headers: {
                                    "Content-Type": "text/plain;charset=utf-8",
                                },
                                data: data,
                            })];
                    case 1:
                        resp = _a.sent();
                        if (resp.status === 200) {
                            return [2 /*return*/, {
                                    success: true,
                                }];
                        }
                        return [2 /*return*/, {
                                success: false,
                            }];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                error: error_1,
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UploadTask.prototype.syncXHR = function (url, payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var xhr = new XMLHttpRequest();
                        xhr.open("POST", url, false); // 第三个参数表明是同步的 xhr
                        xhr.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
                        xhr.onerror = function () {
                            return reject({
                                success: false,
                            });
                        };
                        xhr.onload = function () {
                            return resolve({
                                success: true,
                            });
                        };
                        xhr.send(payload);
                    })];
            });
        });
    };
    UploadTask.prototype.uploadSync = function (data, config) {
        return __awaiter(this, void 0, void 0, function () {
            var url, payload;
            return __generator(this, function (_a) {
                if (!data.length) {
                    return [2 /*return*/];
                }
                url = this.resolveUrl(config.env, config.uploadDomain);
                payload = JSON.stringify(data);
                if (navigator.sendBeacon) {
                    // 数据再次重置
                    // 重置为已上传，因无法捕获返回状态，不重置无法删除，参数为DOMString时，默认text/plain
                    navigator.sendBeacon(url, payload);
                    return [2 /*return*/, Promise.resolve({
                            success: true,
                        })];
                }
                else {
                    return [2 /*return*/, this.syncXHR(url, payload)];
                }
                return [2 /*return*/];
            });
        });
    };
    UploadTask.prototype.execute = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var config, list, transformed, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!context.list.length) {
                            return [2 /*return*/];
                        }
                        config = this.sdkConfigService.get();
                        list = context.list.map(function (l) {
                            // eslint-disable-next-line
                            var __tempCleanedProps = l.__tempCleanedProps, rest = __rest(l, ["__tempCleanedProps"]);
                            return rest;
                        });
                        transformed = this.transformFieldsService.toAbbr(list);
                        this.printLogService.info("upload logs in web\n".concat(JSON.stringify(transformed, null, 2), "\n"));
                        if (!context.syncUpload) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.uploadSync(transformed, config)];
                    case 1:
                        result = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.upload(transformed, config)];
                    case 3:
                        result = _a.sent();
                        _a.label = 4;
                    case 4:
                        context = __assign(__assign({}, context), result);
                        return [2 /*return*/, context];
                }
            });
        });
    };
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IConfigService),
        (0, inversify_1.named)(types_1.TAG.SDKConfigService),
        __metadata("design:type", Object)
    ], UploadTask.prototype, "sdkConfigService", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IAdjustTimeService),
        __metadata("design:type", Object)
    ], UploadTask.prototype, "adjustTimeService", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.ITransformFieldsService),
        __metadata("design:type", Object)
    ], UploadTask.prototype, "transformFieldsService", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IPrintLogService),
        __metadata("design:type", Object)
    ], UploadTask.prototype, "printLogService", void 0);
    UploadTask = __decorate([
        (0, inversify_1.injectable)()
    ], UploadTask);
    return UploadTask;
}());
exports.UploadTask = UploadTask;
